import { IApplicationState } from '../../../types/types';
import { getAuthUser } from '../authUser/selectors/getAuthUser';

export const getUserAffiliateId = (
    state: IApplicationState
): string => {
    const user = getAuthUser(state);
    return user && user.affiliateId;
};
